import { LOADING, LOADED, ERROR } from 'shared_js/constants/commonStatuses';

export default {
  isLoading(state) {
    return state.loadingStatus === LOADING;
  },
  isLoaded(state) {
    return state.loadingStatus === LOADED;
  },
  isError(state) {
    return state.loadingStatus === ERROR;
  },
};
